import { render, staticRenderFns } from "./week-days.vue?vue&type=template&id=2c916aa0&scoped=true&"
import script from "./week-days.vue?vue&type=script&lang=js&"
export * from "./week-days.vue?vue&type=script&lang=js&"
import style0 from "./week-days.vue?vue&type=style&index=0&id=2c916aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c916aa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c916aa0')) {
      api.createRecord('2c916aa0', component.options)
    } else {
      api.reload('2c916aa0', component.options)
    }
    module.hot.accept("./week-days.vue?vue&type=template&id=2c916aa0&scoped=true&", function () {
      api.rerender('2c916aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/week-days.vue"
export default component.exports